import { render, staticRenderFns } from "./TableStaffView.vue?vue&type=template&id=6594bdaa"
import script from "./TableStaffView.vue?vue&type=script&lang=js"
export * from "./TableStaffView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports